import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RestTranslatorModule } from './../../core/translator/rest-translator.module';
import { TabComponent } from './tab/tab.component';
import { TabsComponent } from './tabs.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    TabsComponent,
    TabComponent
  ],
  exports: [
    TabsComponent,
    TabComponent
   ]
})
export class TabsModule { }
